import Vue from 'vue'
import Vuex from 'vuex'

import user from './user.js'
import shared from './shared.js'
import userData from './userData.js'

import products from './products.js'
import channels from './channels.js'
import spots from './spots.js'
import consultancy from './consultancy.js'

import segments from './segments.js'
import summary from './summary.js'
import previous from './previous.js'
import intermediate from './intermediate.js'

import finance from './finance.js'

import article from './article.js'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user, userData, shared, 
		products, channels, spots, consultancy,
		segments, summary, previous, intermediate,
		finance,
		article
	}
})

